import React, { useEffect } from 'react';
import { Switch } from 'react-router';
import { SecureRoute } from '@okta/okta-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import BackToTop from '~COMPONENTS/BackToTop';

import orderRoutes from '../app/router/orderRoutes';

import { deepLinkInfoLoading } from '../user/selectors';
import { getSalesOrg } from '../gamedayAccount/selectors';
import { isRouteVisibleForSalesOrg } from '../util/isRouteVisibleForSalesOrg';

export const Orders = ({ deepLinkInfoLoading, salesOrg }) => {
  useEffect(() => {
    document.body.classList.add('orders');
    return () => document.body.classList.remove('orders');
  });

  if (deepLinkInfoLoading) {
    return null;
  }

  return (
    <div className='content bg-primary-grey'>
      <Switch>
        {orderRoutes.reduce((prevRoute, subRoute) => {
          if (isRouteVisibleForSalesOrg(subRoute, salesOrg)) {
            prevRoute.push(
              <SecureRoute
                key={subRoute.path}
                path={subRoute.path}
                exact={subRoute.exact}
                component={subRoute.component}
              />
            );
          }
          return prevRoute;
        }, [])}
      </Switch>
      <BackToTop />
    </div>
  );
};

Orders.propTypes = {
  deepLinkInfoLoading: PropTypes.bool.isRequired,
  salesOrg: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  deepLinkInfoLoading: deepLinkInfoLoading(state),
  salesOrg: getSalesOrg(state)
});

export default connect(mapStateToProps, {})(Orders);
